import React from 'react';
import { motion } from 'framer-motion';
import { ServicesGrid } from '../components/ServicesGrid';
export function Services() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="bg-white pb-20" data-id="element-558">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 md:pt-20 mb-12 md:mb-16" data-id="element-559">
        <h1 className="text-4xl font-extrabold text-slate-900 mb-8" data-id="element-560">
          Clinical Services
        </h1>
        <p className="text-lg text-slate-600 mb-4 max-w-3xl" data-id="element-561">
          Professional healthcare services provided by our certified
          pharmacists.
        </p>
      </div>
      <ServicesGrid data-id="element-562" />
    </motion.div>;
}